export const getItem = key => {
    try{
        return JSON.parse(localStorage.getItem(key))
    }catch (e){
        console.log("Error getting data from localStorage", e)
        return null
    }
}

export const setItem = (key, data) => {
    try{
        localStorage.setItem(key, JSON.stringify(data))
    }catch (e) {
        console.log("Error saving data in localStorage", e)
    }
}

export const getLang = () => {
    try{
        return getItem('lang')
    }catch (e){
        console.log("Error getting lang from localStorage", e)
        return null
    }
}

export const apiUrlWithLang = url => {
    try{
        let lang = getLang()
        if (lang !== null){
            if (url.indexOf('?') > -1){
                url = `${url}&_lang=${lang}`
            } else {
                url = `${url}?_lang=${lang}`
            }
        }
        return url
    }catch (e){
        console.log("Error set lang in url", e)
        return null
    }
}
